import Notify from "./notifyActions";

export const SUBTEST_PING_SELECTED = "SUBTEST_PING_SELECTED";
export const getSubTestPing = cid => ({
  type: SUBTEST_PING_SELECTED,
  payload: {
    request: {
      mode: "no-cors",
      url: `PingDetails/${cid}`,
      method: "GET"
    }
  }
});

export const SUBTEST_PING4_SUCCESSFULL_TOAST =
  "subtest_ping4_update_successfully_toast";
export const SUBTEST_PING6_SUCCESSFULL_TOAST =
  "subtest_ping6_update_successfully_toast";

export const SUBTEST_PING_UPDATE = "SUBTEST_PING_UPDATE";
export const updateSubTestPing = (type, details) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_PING_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `PingDetails`,
            method: "POST",
            data: {
              request: details
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          if (type == "ping4")
            dispatch(Notify.success(SUBTEST_PING4_SUCCESSFULL_TOAST));
          else dispatch(Notify.success(SUBTEST_PING6_SUCCESSFULL_TOAST));
          dispatch(getSubTestPing(type));
        } else {
          dispatch(getSubTestPing(type));
          reject(response);
        }
      });
    });
  };
};

export const SUBTEST_TR_SELECTED = "SUBTEST_TR_SELECTED";
export const getSubTestTr = cid => ({
  type: SUBTEST_TR_SELECTED,
  payload: {
    request: {
      mode: "no-cors",
      url: `TraceRoute/${cid}`,
      method: "GET"
    }
  }
});

export const SUBTEST_TR4_SUCCESSFULL_TOAST =
  "subtest_tr4_update_successfully_toast";
export const SUBTEST_TR6_SUCCESSFULL_TOAST =
  "subtest_tr6_update_successfully_toast";

export const SUBTEST_TR_UPDATE = "SUBTEST_TR_UPDATE";
export const updateSubTestTr = (type, details) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_TR_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `TraceRoute`,
            method: "POST",
            data: {
              request: details
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          if (type == "traceroute4")
            dispatch(Notify.success(SUBTEST_TR4_SUCCESSFULL_TOAST));
          else dispatch(Notify.success(SUBTEST_TR6_SUCCESSFULL_TOAST));
          dispatch(getSubTestTr(type));
        } else {
          dispatch(getSubTestTr(type));
          reject(response);
        }
      });
    });
  };
};

export const NETSCAN_SETUP_GET = "NETSCAN_SETUP_GET";
export const getNetScan = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: NETSCAN_SETUP_GET,
        payload: {
          request: {
            mode: "no-cors",
            url: `NetScan`,
            method: "GET"
          }
        }
      });
    });
  };
};

export const NETSCAN_SETUP_POST = "NETSCAN_SETUP_POST";
export const SUBTEST_NETSCAN_SUCCESSFULL_TOAST =
  "subtest_netscan_update_successfully_toast";
export const updateNetScan = payload => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: NETSCAN_SETUP_POST,
        payload: {
          request: {
            mode: "no-cors",
            url: `NetScan`,
            method: "POST",
            data: {
              request: payload
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(SUBTEST_NETSCAN_SUCCESSFULL_TOAST));
        } else {
          reject(response);
        }
      });
    });
  };
};

export const SUBTEST_UPTIME_GET = "SUBTEST_UPTIME_GET";
export const getUpTime = () => ({
  type: SUBTEST_UPTIME_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `UpTime`,
      method: "GET"
    }
  }
});

export const SUBTEST_UPTIME_SUCCESSFULL_TOAST =
  "subtest_uptime_update_successfully_toast";

export const SUBTEST_UPTIME_UPDATE = "SUBTEST_UPTIME_UPDATE";
export const updateSubTestUptime = details => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_UPTIME_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `Uptime`,
            method: "POST",
            data: {
              request: details
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(SUBTEST_UPTIME_SUCCESSFULL_TOAST));
          dispatch(getUpTime());
        } else {
          dispatch(getUpTime());
          reject(response);
        }
      });
    });
  };
};

export const MAXTHROUGHPUT_GET = "MAXTHROUGHPUT_GET";
export const getMaxThroughPut = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: MAXTHROUGHPUT_GET,
        payload: {
          request: {
            mode: "no-cors",
            url: `MaxThroughput`,
            method: "GET"
          }
        }
      });
    });
  };
};

export const SUBTEST_MAXTHROUGHPUT_SUCCESSFULL_TOAST =
  "subtest_maxthroughput_update_successfully_toast";
export const SUBTEST_MAXTHROUGHPUT_UNSUCCESSFULL_TOAST =
  "subtest_maxthroughput_update_unsuccessfully_toast";
export const MAXTHROUGHPUT_POST = "MAXTHROUGHPUT_POST";
export const updateMaxThroughPut = payload => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: MAXTHROUGHPUT_POST,
        payload: {
          request: {
            mode: "no-cors",
            url: `MaxThroughput`,
            method: "POST",
            data: {
              request: payload
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(SUBTEST_MAXTHROUGHPUT_SUCCESSFULL_TOAST));
        } else {
          reject(response);
        }
      });
    });
  };
};

export const SUBTEST_WIREMAP_GET = "SUBTEST_WIREMAP_GET";
export const getWireMap = (deviceType) => ({
  type: SUBTEST_WIREMAP_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `Wiremap/${deviceType}`,
      method: "GET"
    }
  }
});

export const SUBTEST_WIREMAP_CABLELIST_GET = "SUBTEST_WIREMAP_CABLELIST_GET";
export const getCableList = id => ({
  type: SUBTEST_WIREMAP_CABLELIST_GET,

  payload: {
    request: {
      mode: "no-cors",
      url: `WiremapCustomCablesList`,
      method: "POST",
      data: {
        request: {
          customerid: id
        }
      }
    }
  }
});

export const CABLELIST_UPDATE_SUCCESSFULL_TOAST =
  "wiremap_custom_cable_update_successfully_toast";

export const SUBTEST_WIREMAP_CABLELIST_UPDATE =
  "SUBTEST_WIREMAP_CABLELIST_UPDATE";
export const updateCableList = details => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_WIREMAP_CABLELIST_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `WiremapCustomCables`,
            method: "POST",
            data: {
              request: details
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(CABLELIST_UPDATE_SUCCESSFULL_TOAST));
          dispatch(
            getCableList(details.customerid ? details.customerid : null)
          );
        } else {
          dispatch(
            getCableList(details.customerid ? details.customerid : null)
          );
          reject(response);
        }
      });
    });
  };
};

export const SUBTESTETTINGS_GET = "SUBTESTETTINGS_GET";
export const getSubtestSettings = type => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTESTETTINGS_GET,
        payload: {
          request: {
            mode: "no-cors",
            url: `SubtestSetting/${type}`,
            method: "GET"
          }
        }
      });
    });
  };
};

export const SUBTEST_CUSTOMDATA_SUCCESSFULL_TOAST =
  "subtest_customdata_update_successfully_toast";
export const SUBTEST_CABLEDATA_SUCCESSFULL_TOAST =
  "subtest_cabledata_update_successfully_toast";
export const SUBTEST_WEBDATA_SUCCESSFULL_TOAST =
  "subtest_webdata_update_successfully_toast";

export const SUBTEST_VOIPDATA_SUCCESSFULL_TOAST =
  "subtest_voipdata_update_successfully_toast";
export const SUBTEST_VIDEODATA_SUCCESSFULL_TOAST =
  "subtest_videodata_update_successfully_toast";
export const SUBTEST_CCTVDATA_SUCCESSFULL_TOAST =
  "subtest_cctvdata_update_successfully_toast";

export const SUBTESTSETTINGS_POST = "SUBTESTSETTINGS_POST";
export const updateSubTestSettings = (payload, type) => {
  return (dispatch, getState) => {
    let notifyMessage = SUBTEST_CUSTOMDATA_SUCCESSFULL_TOAST;
    switch (payload.setuptype) {
      case "cabledata":
        notifyMessage = SUBTEST_CABLEDATA_SUCCESSFULL_TOAST;
        break;
      case "webdata":
        notifyMessage = SUBTEST_WEBDATA_SUCCESSFULL_TOAST;
        break;
      case "voipdata":
        notifyMessage = SUBTEST_VOIPDATA_SUCCESSFULL_TOAST;
        break;
      case "videodata":
        notifyMessage = SUBTEST_VIDEODATA_SUCCESSFULL_TOAST;
        break;
      case "cctvdata":
        notifyMessage = SUBTEST_CCTVDATA_SUCCESSFULL_TOAST;
        break;
    }
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTESTSETTINGS_POST,
        payload: {
          request: {
            mode: "no-cors",
            url: `SubtestSetting`,
            method: "POST",
            data: {
              request: payload
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(notifyMessage));
        } else {
          reject(response);
        }
      });
    });
  };
};

export const CABLE_DELETE_SUCCESSFULL_TOAST =
  "general_sub_test_wiremap_modal_delete_s_cust_cable_head";
export const CABLE_DELETE_FAILED_TOAST =
  "general_sub_test_wiremap_modal_delete_f_cust_cable_head";

export const CABLE_DELETE = "CABLE_DELETE";
export const DeleteCable = (id, custId) => {
  return (dispatch, getState) => {
    dispatch({
      type: CABLE_DELETE,
      payload: {
        request: {
          url: `WiremapCustomCables/${id}`,
          method: "DELETE"
        }
      }
    })
      .then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(CABLE_DELETE_SUCCESSFULL_TOAST));
          dispatch(getCableList(custId));
        } else {
          dispatch(Notify.error(CABLE_DELETE_FAILED_TOAST));
          dispatch(getCableList(custId));
        }
      })
      .catch(error => {
        dispatch(Notify.error(error));
      });
  };
};

export const WIREMAP_UPDATE_SUCCESSFULL_TOAST =
  "wiremap_update_successfully_toast";

export const SUBTEST_WIREMAP_UPDATE = "SUBTEST_WIREMAP_UPDATE";
export const updateWireMap = (details) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SUBTEST_WIREMAP_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: `Wiremap`,
            method: "POST",
            data: {
              request: details
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(WIREMAP_UPDATE_SUCCESSFULL_TOAST));
          dispatch(getWireMap(details.devicetype));
        } else {
          dispatch(getWireMap(details.devicetype));
          reject(response);
        }
      });
    });
  };
};

export const FIBERLENGTHLOSS_SETUP_GET = "FIBERLENGTHLOSS_SETUP_GET";
export const getFiberLengthLoss = (type) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: FIBERLENGTHLOSS_SETUP_GET,
        payload: {
          request: {
            mode: "no-cors",
            url: `FiberLengthLoss/${type}`,
            method: "GET"
          }
        }
      });
    });
  };
};

export const FIBERLENGTHLOSS_SETUP_POST = "FIBERLENGTHLOSS_SETUP_POST";
export const SUBTEST_FIBERLENGTHLOSS_SUCCESSFULL_TOAST =
  "subtest_fiberlengthloss_update_successfully_toast";
export const updateFiberLengthLoss = payload => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: FIBERLENGTHLOSS_SETUP_POST,
        payload: {
          request: {
            mode: "no-cors",
            url: `FiberLengthLoss`,
            method: "POST",
            data: {
              request: payload
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(SUBTEST_FIBERLENGTHLOSS_SUCCESSFULL_TOAST));
        } else {
          reject(response);
        }
      });
    });
  };
};

export const QUALIFICATION_SETUP_GET = "QUALIFICATION_SETUP_GET";
export const getQualification = () => ({
  type: QUALIFICATION_SETUP_GET,

  payload: {
    request: {
      mode: "no-cors",
      url: `Qualification`,
      method: "GET",
    }
  }
});

export const QUALIFICATION_SETUP_POST = "QUALIFICATION_SETUP_POST";
export const SUBTEST_QUALIFICATION_SUCCESSFULL_TOAST =
  "subtest_qualification_update_successfully_toast";
export const updateQualification = payload => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: QUALIFICATION_SETUP_POST,
        payload: {
          request: {
            mode: "no-cors",
            url: `Qualification`,
            method: "POST",
            data: {
              request: payload
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(SUBTEST_QUALIFICATION_SUCCESSFULL_TOAST));
        } else {
          reject(response);
        }
      });
    });
  };
};
